/**
 * @desc 获取商户分期提额码信息V2
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** sign */
  sign: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/merchant/merchantCreditCodeInfoV2',
    params,
    method: 'get',
  })
}
